import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { connect } from "react-redux";
import { formattedBranchName } from "../../helpers/formatter";

const BannerFourSingle = ({ data, spaceBottomClass }) => {
  const curr_location = useSelector((state) => state.locationsData.location)
  return (
    <div className="col-lg-4 col-md-4">
      <div
        className={`single-banner banner-shape banner-white-color ${
          spaceBottomClass ? spaceBottomClass : ""
        }`}
      >
        <Link
          to={{
            pathname:
              process.env.PUBLIC_URL +
              `/${formattedBranchName(curr_location.name)}/programs`,
            grade: data.title,
          }}
        >
          <img src={process.env.PUBLIC_URL + data.image} alt="" />
        </Link>
        <div className="banner-content">
          <h3>{data.title}</h3>
          <h4>
            {data.subtitle} <span>{data.price}</span>
          </h4>
          <Link
            to={{
              pathname:
                process.env.PUBLIC_URL +
                `/${formattedBranchName(curr_location.name)}/programs`,
              grade: data.title,
            }}
          >
            <i className=" fa fa-long-arrow-right" />
          </Link>
        </div>
      </div>
    </div>
  );
};

BannerFourSingle.propTypes = {
  data: PropTypes.object,
  spaceBottomClass: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
  cLocation: state.locationsData.location
  }
}


export default connect(mapStateToProps)(BannerFourSingle);
